if (!customElements.get('infinity-scroll')) {
  customElements.define('infinity-scroll', class InfinityScroll extends HTMLElement {
    constructor() {
      super();

      this.settings = {
        pagination: this.getAttribute('pagination'),
        method: this.getAttribute('method'),
        container: this.getAttribute('container'),
        offset: 0,
        loadingText: this.getAttribute('loadingText'),
        btnTitle: this.getAttribute('btnTitle'),
        btnPrevTitle: this.getAttribute('btnPrevTitle'),
        prevBtn: '#PreviousPage',
        callback: null
      };

      this.loadingMoreItems = false;

      if (!this.settings.method) {
        this.settings.method = document.querySelector('.product-grid-container .collection:last-child .pagination-loader')
          ? 'scroll'
          : 'click';
      }

      document.querySelector('body').classList.add('infinity-loop-enabled');

      this.allPaginations = null;
      this.pagesAdded = [];
      this.pagesLoading = [];
      this.soldOutItemsBuffer = [];

      /*
       * Prevent duplicate products from being rendered.
       * Keys are based on product identity, not DOM identity.
       */
      this.renderedItemKeys = [];
      this.soldOutBufferKeys = [];

      /*
       * Initial-grid priming.
       *
       * Sold-out products are intentionally buffered so available products can
       * stay ahead of them across paginated collection pages. The downside is
       * that a first page containing only 1-2 available products can look almost
       * empty until the visitor scrolls.
       *
       * To preserve the existing behavior without preloading the whole
       * collection, we only auto-load more pages when the initial grid is very
       * sparse. Once at least 8 available products are visible (or there are no
       * more pages), normal infinite scroll resumes.
       */
      this.initialGridPriming = false;
      this.initialGridPrimed = false;
      this.initialGridTargetCount = 0;
      this.initialGridMinimumVisible = 8;

      this.loadingBtn = false;
      this.currentPage = parseInt(this.getAttribute('currentPage'), 10);
      this.pageIndex = this.currentPage;
      this.currentPageview = null;

      this.addScrollListeners = this.addScrollListeners.bind(this);
      this.addClickListener = this.addClickListener.bind(this);
      this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
      this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
      this.destroy = this.destroy.bind(this);

      this.containerElement = document.querySelector(this.settings.container);
      this.paginationElement = document.querySelector(this.settings.pagination);

      window.pagination = {};

      this.initialize();
    }

    saveScrollPosition(event) {
      let itemClicked = event ? event.currentTarget : null;
      let container = document.querySelector(this.settings.container);

      if (itemClicked && container) {
        let data = {
          id: itemClicked.getAttribute('id'),
          top: container.scrollTop - document.body.scrollTop
        };

        localStorage.setItem('last-seen', JSON.stringify(data));
      }
    }

    initialize() {
      if (this.containerElement) {
        var initializers = {
          click: this.addClickListener,
          scroll: this.addScrollListeners
        };

        this.bufferInitialSoldOutItems();

        /*
         * Before binding the regular infinite-scroll observer, make sure the
         * initial grid did not collapse to just a handful of available items
         * after sold-out products were moved to the buffer.
         */
        if (this.shouldPrimeInitialGrid()) {
          this.startInitialGridPriming();
          return;
        }

        if (this.id == 'PreviousPage') {
          this.addClickListener();
        } else if (initializers[this.settings.method]) {
          initializers[this.settings.method]();
        }

        this.observeCollectionPages();
      }
    }

    updateUrlPage(pageIndex) {
  /*
   * Do not update the URL during infinite scroll.
   *
   * Reason:
   * If the URL becomes ?page=2 / ?page=3 and the user refreshes,
   * Shopify renders only that paginated page instead of the products
   * already loaded by infinite scroll.
   */
  return;
}

    markPageAdded(pageIndex) {
      pageIndex = parseInt(pageIndex, 10);

      if (!isNaN(pageIndex) && !this.pagesAdded.includes(pageIndex)) {
        this.pagesAdded.push(pageIndex);
      }
    }

    markPageLoading(pageIndex) {
      pageIndex = parseInt(pageIndex, 10);

      if (!isNaN(pageIndex) && !this.pagesLoading.includes(pageIndex)) {
        this.pagesLoading.push(pageIndex);
      }
    }

    unmarkPageLoading(pageIndex) {
      pageIndex = parseInt(pageIndex, 10);

      this.pagesLoading = this.pagesLoading.filter((page) => {
        return page !== pageIndex;
      });
    }

    observeCollectionPages() {
      const collections = document.querySelectorAll('div.collection');

      const options = {
        threshold: 0.1
      };

      const collectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const collection = entry.target;
            const currentPageIndex = parseInt(collection.getAttribute('page'), 10);

            if (isNaN(currentPageIndex)) {
              return;
            }

            this.currentPageview = currentPageIndex;
            this.updateUrlPage(currentPageIndex);
            this.markPageAdded(currentPageIndex);
          }
        });
      }, options);

      if (collections.length) {
        collections.forEach((collection) => {
          collectionObserver.observe(collection);
        });
      }
    }

    addScrollListeners() {
      if (this.paginationElement) {
        let pagination = document.querySelector('.product-grid-container .collection:last-child .pagination-loader');

        if (!pagination) {
          return;
        }

        let options = {
          threshold: 0.1,
          rootMargin: window.innerWidth >= 990
            ? '0px 0px 1400px 0px'
            : '0px 0px 600px 0px'
        };

        let observer = new IntersectionObserver(entries => {
          let entry = entries[0];

          if (entry.isIntersecting) {
            this.checkIfPaginationInView();
            observer.unobserve(pagination);
          } else {
            let url = new URL(window.location.href);
            var visiblepage = url.searchParams.get('page');

            if (visiblepage) {
              let pages = document.querySelectorAll('.page-num');

              if (pages.length) {
                const pagesObserver = new IntersectionObserver((entries) => {
                  let entry = entries[0];

                  if (entry.isIntersecting) {
                    let elm = entry.target;
                    let ind = elm.getAttribute('id');

                    if (ind == 'pageNaN') {
                      ind = 1;
                    } else {
                      ind = ind.replace('page', '');
                    }

                    ind = parseInt(ind, 10);

                    if (!isNaN(ind)) {
                      this.updateUrlPage(ind);
                    }
                  }
                }, {
                  threshold: 0.1
                });

                pages.forEach(page => {
                  pagesObserver.observe(page);
                });
              }
            }
          }
        }, options);

        observer.observe(pagination);
      }
    }

    hideAllLoaders(showLast) {
      let allLoaders = this.containerElement.querySelectorAll('.collection .pagination-loader');

      allLoaders.forEach((elm, idx) => {
        if (idx === allLoaders.length - 1 && showLast) {
          return;
        }

        elm.style.display = 'none';
      });
    }

    addClickListener() {
      let allPaginations = document.querySelectorAll('.infinite-loop');

      allPaginations.forEach((pager) => {
        this.nextPageLinkElement = pager.querySelector('a');

        if (
          this.nextPageLinkElement &&
          this.nextPageLinkElement.getAttribute('data-infinity-click-bound') !== 'true'
        ) {
          this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks.bind(this));
          this.nextPageLinkElement.setAttribute('data-infinity-click-bound', 'true');
        }
      });
    }

    stopMultipleClicks(event) {
      event.preventDefault();

      let element = event.currentTarget || event.target;
      let clickActive = element.getAttribute('clickActive');

      if (element && clickActive == 1 && !this.loadingMoreItems) {
        element.textContent = this.settings.loadingText;
        this.loadingBtn = element.parentElement;
        this.nextPageUrl = element.href;
        this.direction = element.getAttribute('direction');
        element.setAttribute('clickActive', 0);

        let pageIndex = parseInt(element.getAttribute('data-num'), 10);

        if (
          !this.pagesAdded.includes(pageIndex) &&
          !this.pagesLoading.includes(pageIndex)
        ) {
          this.loadingMoreItems = true;
          this.markPageLoading(pageIndex);
          this.loadMore(pageIndex, this.direction, element);
        }
      }
    }

    hideLoadingButton(element) {
      return element.classList.add('loaded');
    }

    checkIfPaginationInView() {
      var throttleTimer;

      const throttle = (callback, time) => {
        if (throttleTimer) return;

        throttleTimer = true;

        setTimeout(() => {
          callback();
          throttleTimer = false;
        }, time);
      };

      this.paginationElement = document.querySelector('.product-grid-container .collection:last-child .infinite-loop');

      if (this.paginationElement && this.paginationElement.querySelector('a')) {
        throttle(() => {
          this.nextPageLinkElement = this.paginationElement.querySelector('a');

          if (this.nextPageLinkElement) {
            let pageIndex = parseInt(this.nextPageLinkElement.getAttribute('data-num'), 10);

            this.nextPageUrl = this.nextPageLinkElement.href;

            if (isNaN(this.currentPage)) {
              this.currentPage = pageIndex - 1;
            }

            if (
              !this.loadingMoreItems &&
              !this.pagesAdded.includes(pageIndex) &&
              !this.pagesLoading.includes(pageIndex) &&
              (pageIndex - 1 == this.currentPage)
            ) {
              this.loadingMoreItems = true;
              this.markPageLoading(pageIndex);
              this.loadMore(pageIndex, 'next');
            }
          }
        }, 300);
      }
    }

    remove(collections) {
      collections.forEach((collection) => {
        collection.remove();
      });
    }

    unload(direction, pageIndex) {
      if (!pageIndex > 3) {
        return;
      }

      const totalPagesToRemove = 2;

      var collections = document.querySelectorAll('#ProductGridContainer .collection');

      if (collections.length > (totalPagesToRemove + 1)) {
        if (direction == 'next') {
          collections = document.querySelectorAll('#ProductGridContainer .collection:nth-child(-n+ ' + totalPagesToRemove + ')');
        } else {
          collections = document.querySelectorAll('#ProductGridContainer .collection:nth-last-child(-n+ ' + totalPagesToRemove + ')');
        }

        this.allPaginations = document.querySelectorAll('.infinite-loop');

        let prevIndex = pageIndex - totalPagesToRemove;

        this.pagesAdded = [];

        this.allPaginations.forEach((pagination) => {
          if (pagination.classList.contains('p-' + prevIndex)) {
            pagination.querySelector('a').style.display = 'flex';
            pagination.querySelector('a').setAttribute('clickactive', 1);
            pagination.querySelector('a').setAttribute('direction', 'prev');
            pagination.querySelector('a').textContent = this.settings.btnPrevTitle;
            pagination.querySelector('a').classList.add('button', 'default');

            if (document.querySelector('#PreviousPage')) {
              document.querySelector('#PreviousPage').innerHTML = pagination.outerHTML;
            }
          }
        });

        this.remove(collections);

        document.querySelectorAll('.product-grid-container .collection').forEach((collection) => {
          var i = parseInt(collection.getAttribute('page'), 10);

          if (!isNaN(i)) {
            this.markPageAdded(i);
          }
        });

        if (document.querySelector('#ProductGridContainer .collection:last-child .pagination-loader')) {
          this.addScrollListeners();
        } else {
          this.addClickListener();
        }
      }
    }

    getProductCardFromItem(item) {
      if (!item) {
        return null;
      }

      return item.querySelector('[data-product-card]');
    }

    getItemKey(item) {
      if (!item) {
        return '';
      }

      let card = this.getProductCardFromItem(item);

      /*
       * Prefer real product identity over DOM identity.
       * DOM ids/classes can change between renders and can cause duplicate detection to fail.
       */
      let productId =
        item.getAttribute('data-product-id') ||
        item.getAttribute('data-product') ||
        item.getAttribute('data-product-id-value') ||
        (card && (
          card.getAttribute('data-product-id') ||
          card.getAttribute('data-product') ||
          card.getAttribute('data-product-id-value')
        ));

      if (productId) {
        return 'product-id:' + productId;
      }

      /*
       * Product handle from product URL is the safest fallback.
       * Handles:
       * /products/product-handle
       * /collections/collection-handle/products/product-handle
       * /products/product-handle?variant=123
       */
      let productLink = item.querySelector('a[href*="/products/"]');

      if (productLink) {
        let href = productLink.getAttribute('href') || '';

        try {
          let url = new URL(href, window.location.origin);
          let match = url.pathname.match(/\/products\/([^\/?#]+)/);

          if (match && match[1]) {
            return 'product-handle:' + match[1];
          }
        } catch (error) {
          let match = href.match(/\/products\/([^\/?#]+)/);

          if (match && match[1]) {
            return 'product-handle:' + match[1];
          }
        }
      }

      /*
       * Last fallback only.
       * Do not prefer item id, because the same product can get different DOM ids.
       */
      return item.outerHTML.slice(0, 250);
    }

    registerRenderedItem(item) {
      let key = this.getItemKey(item);

      if (key && !this.renderedItemKeys.includes(key)) {
        this.renderedItemKeys.push(key);
      }
    }

    unregisterRenderedItem(item) {
      let key = this.getItemKey(item);

      if (!key) {
        return;
      }

      this.renderedItemKeys = this.renderedItemKeys.filter((itemKey) => {
        return itemKey !== key;
      });
    }

    isItemRendered(item) {
      let key = this.getItemKey(item);

      return key && this.renderedItemKeys.includes(key);
    }

    isItemInSoldOutBuffer(item) {
      let key = this.getItemKey(item);

      return key && this.soldOutBufferKeys.includes(key);
    }

    filterDuplicateItems(items) {
      if (!items || !items.length) {
        return [];
      }

      let seenInThisBatch = [];

      return items.filter((item) => {
        let key = this.getItemKey(item);

        if (!key) {
          return false;
        }

        if (
          this.renderedItemKeys.includes(key) ||
          this.soldOutBufferKeys.includes(key) ||
          seenInThisBatch.includes(key)
        ) {
          return false;
        }

        seenInThisBatch.push(key);
        return true;
      });
    }

    removeDuplicateRenderedItems() {
      let grid = this.getMainProductGrid();

      if (!grid) {
        return;
      }

      let seen = [];

      let items = Array.from(grid.children).filter((item) => {
        return item.matches('li') && this.getProductCardFromItem(item);
      });

      items.forEach((item) => {
        let key = this.getItemKey(item);

        if (!key) {
          return;
        }

        if (seen.includes(key)) {
          item.remove();
          return;
        }

        seen.push(key);
      });

      this.renderedItemKeys = seen.slice();
    }

    isSoldOutItem(item) {
      let card = this.getProductCardFromItem(item);

      if (!card) {
        return false;
      }

      let value = (card.getAttribute('data-available') || '').toLowerCase();

      return value === 'false' || value === '0' || value === 'no';
    }

    splitItemsByAvailability(items) {
      let availableItems = [];
      let soldOutItems = [];

      items.forEach((item) => {
        if (this.isSoldOutItem(item)) {
          soldOutItems.push(item);
        } else {
          availableItems.push(item);
        }
      });

      return {
        availableItems: availableItems,
        soldOutItems: soldOutItems
      };
    }

    appendItems(target, items, position) {
      if (!target || !items || !items.length) {
        return;
      }

      items.forEach((item) => {
        if (this.isItemRendered(item)) {
          return;
        }

        target.insertAdjacentHTML(position || 'beforeend', item.outerHTML);

        let insertedItem;

        if ((position || 'beforeend') === 'afterbegin') {
          insertedItem = target.firstElementChild;
        } else {
          insertedItem = target.lastElementChild;
        }

        if (insertedItem) {
          this.registerRenderedItem(insertedItem);
        }
      });
    }

    addSoldOutItemsToBuffer(items) {
      if (!items || !items.length) {
        return;
      }

      items.forEach((item) => {
        let key = this.getItemKey(item);

        if (!key || this.soldOutBufferKeys.includes(key) || this.renderedItemKeys.includes(key)) {
          return;
        }

        this.soldOutItemsBuffer.push(item);
        this.soldOutBufferKeys.push(key);
      });
    }

    moveRenderedSoldOutItemsToBuffer() {
      let grid = this.getMainProductGrid();

      if (!grid) {
        return;
      }

      let renderedItems = Array.from(grid.children).filter((item) => {
        return item.matches('li') && this.getProductCardFromItem(item);
      });

      let splitItems = this.splitItemsByAvailability(renderedItems);

      splitItems.soldOutItems.forEach((item) => {
        let key = this.getItemKey(item);

        if (key && !this.soldOutBufferKeys.includes(key)) {
          this.soldOutItemsBuffer.push(item.cloneNode(true));
          this.soldOutBufferKeys.push(key);
        }

        this.unregisterRenderedItem(item);
        item.remove();
      });
    }

    hasRenderedAvailableItems() {
      let grid = this.getMainProductGrid();

      if (!grid) {
        return false;
      }

      let renderedItems = Array.from(grid.children).filter((item) => {
        return item.matches('li') && this.getProductCardFromItem(item);
      });

      return renderedItems.some((item) => {
        return !this.isSoldOutItem(item);
      });
    }

    getRenderedAvailableItemCount() {
      let grid = this.getMainProductGrid();

      if (!grid) {
        return 0;
      }

      let renderedItems = Array.from(grid.children).filter((item) => {
        return item.matches('li') && this.getProductCardFromItem(item);
      });

      return renderedItems.filter((item) => {
        return !this.isSoldOutItem(item);
      }).length;
    }

    getNextPageLink(container) {
      let root = container || document;

      if (!root || !root.querySelector) {
        return null;
      }

      return (
        root.querySelector('.product-grid-container .collection:last-child .infinite-loop a[direction="next"][href]') ||
        root.querySelector('.infinite-loop a[direction="next"][href]') ||
        root.querySelector('a[rel="next"][href]')
      );
    }

    getPageIndexFromLink(link) {
      if (!link) {
        return NaN;
      }

      let pageIndex = parseInt(link.getAttribute('data-num'), 10);

      if (!isNaN(pageIndex)) {
        return pageIndex;
      }

      try {
        let url = new URL(link.href, window.location.origin);
        pageIndex = parseInt(url.searchParams.get('page'), 10);
      } catch (error) {
        pageIndex = NaN;
      }

      return pageIndex;
    }

    shouldPrimeInitialGrid() {
      if (this.initialGridPrimed || this.id == 'PreviousPage') {
        return false;
      }

      /*
       * Keep click-based pagination behavior untouched. This safeguard is only
       * for the scroll mode used by the collection grid.
       */
      if (this.settings.method !== 'scroll') {
        this.initialGridPrimed = true;
        return false;
      }

      let grid = this.getMainProductGrid();

      if (!grid || !this.initialGridTargetCount) {
        this.initialGridPrimed = true;
        return false;
      }

      let minimumVisible = Math.min(
        this.initialGridMinimumVisible,
        this.initialGridTargetCount
      );

      if (this.getRenderedAvailableItemCount() >= minimumVisible) {
        this.initialGridPrimed = true;
        return false;
      }

      let nextPageLink = this.getNextPageLink(document);

      if (!nextPageLink) {
        /*
         * No more pages exist. At this point there is nothing left to search
         * for, so put the buffered sold-out products back after the available
         * products.
         */
        this.flushSoldOutItems(grid);
        this.initialGridPrimed = true;
        return false;
      }

      return true;
    }

    startInitialGridPriming() {
      if (
        this.initialGridPrimed ||
        this.initialGridPriming ||
        this.loadingMoreItems
      ) {
        return false;
      }

      let nextPageLink = this.getNextPageLink(document);

      if (!nextPageLink) {
        this.initialGridPrimed = true;
        return false;
      }

      let pageIndex = this.getPageIndexFromLink(nextPageLink);

      if (isNaN(pageIndex)) {
        this.initialGridPrimed = true;
        return false;
      }

      if (
        this.pagesAdded.includes(pageIndex) ||
        this.pagesLoading.includes(pageIndex)
      ) {
        this.initialGridPrimed = true;
        return false;
      }

      this.nextPageUrl = nextPageLink.href;
      this.initialGridPriming = true;
      this.loadingMoreItems = true;
      this.markPageLoading(pageIndex);
      this.loadMore(pageIndex, 'next', null, true);

      return true;
    }

    hasNextPage(container) {
      if (!container) {
        return false;
      }

      return Boolean(
        container.querySelector('.product-grid-container .collection:last-child .infinite-loop a[href]') ||
        container.querySelector('.infinite-loop a[href]') ||
        container.querySelector('.pagination-wrapper a[href*="page="]') ||
        container.querySelector('a[rel="next"]')
      );
    }

    getMainProductGrid() {
      return (
        document.querySelector('#product-grid') ||
        document.querySelector('[id*="product-grid"]') ||
        document.querySelector('.product-grid')
      );
    }

    flushSoldOutItems(target) {
      if (!target || !this.soldOutItemsBuffer.length) {
        return;
      }

      this.soldOutItemsBuffer.forEach((item) => {
        if (this.isItemRendered(item)) {
          return;
        }

        target.insertAdjacentHTML('beforeend', item.outerHTML);

        let insertedItem = target.lastElementChild;

        if (insertedItem) {
          this.registerRenderedItem(insertedItem);
        }
      });

      this.soldOutItemsBuffer = [];
      this.soldOutBufferKeys = [];
    }

    registerInitialRenderedItems(grid) {
      if (!grid) {
        return;
      }

      let items = Array.from(grid.children).filter((item) => {
        return item.matches('li') && this.getProductCardFromItem(item);
      });

      items.forEach((item) => {
        this.registerRenderedItem(item);
      });
    }

    bufferInitialSoldOutItems() {
      let grid = this.getMainProductGrid();

      if (!grid || grid.getAttribute('data-sold-out-buffered') === 'true') {
        return;
      }

      let items = Array.from(grid.children).filter((item) => {
        return item.matches('li') && this.getProductCardFromItem(item);
      });

      if (!items.length) {
        grid.setAttribute('data-sold-out-buffered', 'true');
        return;
      }

      /*
       * Remember how many real product cards Shopify rendered on the initial
       * paginated page before sold-out products are removed from view.
       */
      if (!this.initialGridTargetCount) {
        this.initialGridTargetCount = items.length;
      }

      let splitItems = this.splitItemsByAvailability(items);

      /*
       * If the initial visible page is entirely sold out, keep it visible.
       * Do not remove all items from the grid, otherwise the grid collapses
       * and the loader can fire too early.
       *
       * If later pages include available products, loadMore() will move these
       * rendered sold-out items into the buffer and keep available products first.
       */
      if (
        splitItems.availableItems.length === 0 &&
        splitItems.soldOutItems.length > 0
      ) {
        this.registerInitialRenderedItems(grid);
        grid.setAttribute('data-sold-out-buffered', 'true');
        return;
      }

      this.registerInitialRenderedItems(grid);

      if (!splitItems.soldOutItems.length) {
        grid.setAttribute('data-sold-out-buffered', 'true');
        return;
      }

      splitItems.soldOutItems.forEach((item) => {
        this.unregisterRenderedItem(item);
        item.remove();
      });

      this.addSoldOutItemsToBuffer(splitItems.soldOutItems);

      grid.setAttribute('data-sold-out-buffered', 'true');

      if (!this.hasNextPage(document)) {
        this.flushSoldOutItems(grid);
        this.loadingMoreItems = false;
      }
    }

    loadMore(pageIndex, direction, btnClicked, isInitialPrime) {
      pageIndex = parseInt(pageIndex, 10);

      if (isNaN(pageIndex)) {
        this.loadingMoreItems = false;

        if (isInitialPrime) {
          this.initialGridPriming = false;
          this.initialGridPrimed = true;
          this.initialize();
        }

        return false;
      }

      if (!this.nextPageUrl) {
        this.loadingMoreItems = false;

        if (isInitialPrime) {
          this.initialGridPriming = false;
          this.initialGridPrimed = true;
          this.initialize();
        }

        return false;
      }

      this.request = new XMLHttpRequest();

      this.request.onreadystatechange = function () {
        if (this.request.readyState !== 4) {
          return;
        }

        if (this.request.status !== 200 || !this.request.responseXML) {
          this.loadingMoreItems = false;
          this.unmarkPageLoading(pageIndex);

          if (isInitialPrime) {
            this.initialGridPriming = false;
            this.initialGridPrimed = true;
            this.initialize();
          }

          return;
        }

        let newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
        this.allPaginations = this.request.responseXML.querySelectorAll(this.settings.pagination);

        let prevBtn = this.request.responseXML.querySelectorAll(this.settings.prevBtn)[0];
        let showLastLoader = true;

        if (!newContainer) {
          this.loadingMoreItems = false;
          this.unmarkPageLoading(pageIndex);

          if (isInitialPrime) {
            this.initialGridPriming = false;
            this.initialGridPrimed = true;
            this.initialize();
          }

          return;
        }

        if (direction == 'next') {
          let lastUL = this.containerElement.querySelector('ul:last-of-type');

          let newLIs = Array.from(newContainer.querySelectorAll('li')).filter((item) => {
            return this.getProductCardFromItem(item);
          });

          newLIs = this.filterDuplicateItems(newLIs);

          let newBtn = newContainer.querySelector('button');
          let newLink = newContainer.querySelector('link');
          let newPaginationWrapperDiv = newContainer.querySelector('div.pagination-wrapper');
          let currentBtn = this.containerElement.querySelector('button');
          let currentLink = this.containerElement.querySelector('link');
          let currentPaginationWrapperDiv = this.containerElement.querySelector('div.pagination-wrapper');

          if (currentBtn && newBtn) currentBtn.replaceWith(newBtn.cloneNode(true));
          if (currentLink && newLink) currentLink.replaceWith(newLink.cloneNode(true));

          if (currentPaginationWrapperDiv && newPaginationWrapperDiv) {
            currentPaginationWrapperDiv.replaceWith(newPaginationWrapperDiv.cloneNode(true));
          } else if (currentPaginationWrapperDiv && !newPaginationWrapperDiv) {
            currentPaginationWrapperDiv.remove();
          }

          /*
           * Keep the actual infinite-scroll pager in the live DOM synchronized
           * with the pager returned by the newly fetched Shopify page.
           *
           * The old implementation assigned paginate.innerHTML to
           * this.paginationElement, which turns an element reference into a
           * string but does not update the DOM. That can leave the old page link
           * in place and prevent subsequent pages from loading correctly.
           */
          let currentInfiniteLoop = this.containerElement.querySelector(
            '.collection:last-child .infinite-loop'
          );
          let newInfiniteLoop = newContainer.querySelector(
            '.collection:last-child .infinite-loop'
          ) || newContainer.querySelector('.infinite-loop');

          if (currentInfiniteLoop && newInfiniteLoop) {
            currentInfiniteLoop.replaceWith(newInfiniteLoop.cloneNode(true));
          } else if (currentInfiniteLoop && !newInfiniteLoop) {
            currentInfiniteLoop.remove();
          }

          let splitItems = this.splitItemsByAvailability(newLIs);
          let hasAnotherPage = this.hasNextPage(newContainer);

          /*
           * If the page currently shows only sold-out products, and the newly loaded page
           * contains available products, move rendered sold-out products to the buffer
           * before appending available products.
           */
          if (
            splitItems.availableItems.length > 0 &&
            !this.hasRenderedAvailableItems()
          ) {
            this.moveRenderedSoldOutItemsToBuffer();
          }

          this.appendItems(lastUL, splitItems.availableItems, 'beforeend');
          this.addSoldOutItemsToBuffer(splitItems.soldOutItems);

          if (!hasAnotherPage) {
            this.flushSoldOutItems(lastUL);
          }
        } else {
          let firstUL = this.containerElement.querySelector('ul:first-of-type');

          let newLIs = Array.from(newContainer.querySelectorAll('li')).filter((item) => {
            return this.getProductCardFromItem(item);
          });

          newLIs = this.filterDuplicateItems(newLIs);

          let splitItems = this.splitItemsByAvailability(newLIs);

          this.appendItems(firstUL, splitItems.availableItems.reverse(), 'afterbegin');
          this.addSoldOutItemsToBuffer(splitItems.soldOutItems);
        }

        if (prevBtn && direction != 'next') {
          if (document.querySelector('#PreviousPage')) {
            document.querySelector('#PreviousPage').innerHTML = prevBtn.outerHTML;
          }
        }

        /*
         * Refresh the element reference after the live pager has been replaced.
         */
        this.paginationElement = this.containerElement.querySelector(
          '.collection:last-child .infinite-loop'
        );

        this.updateUrlPage(pageIndex);
        this.currentPage = pageIndex;
        this.markPageAdded(pageIndex);
        this.unmarkPageLoading(pageIndex);

        this.hideAllLoaders(showLastLoader);

        if (this.loadingBtn) {
          this.hideLoadingButton(this.loadingBtn);
        }

        if (this.settings.callback && typeof this.settings.callback === 'function') {
          this.settings.callback(this.request.responseXML);
        }

        if (btnClicked) {
          btnClicked.style.display = 'none';
        }

        this.unload(direction, pageIndex);

        /*
         * During initial priming, do not bind a new scroll observer after every
         * AJAX page. We either prime another page immediately or, once priming
         * is complete, initialize the regular infinite-scroll behavior once.
         */
        if (!isInitialPrime) {
          this.initialize();
        }

        let grid = this.getMainProductGrid();

        if (grid && !this.hasNextPage(document)) {
          this.flushSoldOutItems(grid);
        }

        this.removeDuplicateRenderedItems();

        this.loadingMoreItems = false;

        if (isInitialPrime) {
          this.initialGridPriming = false;

          if (this.shouldPrimeInitialGrid()) {
            this.startInitialGridPriming();
          } else {
            this.initialize();
          }
        }
      }.bind(this);

      this.request.open('GET', this.nextPageUrl);
      this.request.responseType = 'document';
      this.request.send();
    }

    removeClickListener() {
      if (this.nextPageLinkElement) {
        this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
      }
    }

    destroy() {
      var destroyers = {
        click: this.removeClickListener
      };

      if (destroyers[this.settings.method]) {
        destroyers[this.settings.method]();
      }

      return this;
    }
  });
}